/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: 14.5px;
  color: #90a9c0;
  cursor: pointer;
`;
Wrapper.displayName = 'Wrapper';
